import React, { useState } from "react";
import { Link } from "react-router-dom";
import Banner from "../components/Banner";
import { FaFileUpload, FaArrowRight } from 'react-icons/fa'
import Breadcrumb from "../components/Breadcrumb";
import { motion, AnimatePresence } from "framer-motion";
import SEO from "../components/SEO";
import jobsData from "../data/JobsData";
import { useNavigate } from "react-router-dom";
import "../styles/pages/Jobs.css";
import JobsBanner from '../images/career-bg.jpeg'

const Jobs = () => {

    const navigate = useNavigate();

    /* First accordion active */
    const [openIndex, setOpenIndex] = useState(0);

    const [showForm, setShowForm] = useState(false);


    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    const fadeUp = {
        hidden: { opacity: 0, y: 50 },
        show: {
            opacity: 1, y: 0,
            transition: { duration: 0.7, ease: "easeOut" }
        }
    };

    return (

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
        >

            <SEO title="Jobs" description="Career Opportunities" />

            <Banner title="CAREER OPPORTUNITIES" image={JobsBanner} />

            <div className="jobs-main py-5">


                <Breadcrumb />
                <div className="container ">
                    <motion.h2
                        className="jobs-title mb-4"
                        initial={{ y: 40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.6 }}
                    >

                        BUILD A FUTURE YOU BELIEVE IN

                    </motion.h2>


                    <motion.div
                        className="jobs-box"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3 }}
                    >


                        {jobsData.map((job, index) => (

                            <motion.div
                                key={job.id}
                                className="job-item"

                                initial={{ y: 50, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: index * 0.15 }}
                            >


                                {/* HEADER */}

                                <div
                                    className="job-header"
                                    onClick={() => toggleAccordion(index)}
                                >

                                    <div className="job-left">

                                        <span className="job-dot"></span>

                                        <div>

                                            <h4>{job.title}</h4>

                                            <span className="job-date">

                                                📅 {job.date}

                                            </span>

                                        </div>

                                    </div>


                                    <motion.span
                                        className="accordion-icon"
                                        animate={{
                                            rotate: openIndex === index ? 180 : 0
                                        }}
                                        transition={{ duration: 0.3 }}
                                    >

                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M6 9L12 15L18 9"
                                                stroke="#9D5CFF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>

                                    </motion.span>

                                </div>


                                {/* ACCORDION BODY */}

                                <AnimatePresence>

                                    {openIndex === index && (

                                        <motion.div

                                            className="job-content"

                                            initial={{ height: 0, opacity: 0 }}

                                            animate={{ height: "auto", opacity: 1 }}

                                            exit={{ height: 0, opacity: 0 }}

                                            transition={{ duration: 0.4 }}

                                        >

                                            <motion.p
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.2 }}
                                            >

                                                {job.shortDesc}

                                            </motion.p>



                                            <div className="job-buttons">


                                                <motion.button

                                                    className="apply-btn"

                                                    whileHover={{ scale: 1.05 }}

                                                    whileTap={{ scale: 0.95 }}

                                                    onClick={() => setShowForm(true)}

                                                >

                                                    Apply Now

                                                </motion.button>



                                                <motion.button

                                                    className="details-btn"

                                                    whileHover={{ scale: 1.05 }}

                                                    whileTap={{ scale: 0.95 }}

                                                    onClick={() => navigate(`/jobs/${job.id}`)}

                                                >

                                                    More Details

                                                </motion.button>


                                            </div>

                                        </motion.div>

                                    )}

                                </AnimatePresence>


                            </motion.div>

                        ))}

                    </motion.div>

                </div>
            </div>




            {/* POPUP FORM */}


            <AnimatePresence>

                {showForm && (

                    <motion.div

                        className="popup-overlay"

                        initial={{ opacity: 0 }}

                        animate={{ opacity: 1 }}

                        exit={{ opacity: 0 }}

                    >

                        <motion.div
                            className="popup-form"
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                        >

                            {/* Close Icon */}

                            <div
                                className="popup-close"
                                onClick={() => setShowForm(false)}
                            >

                                <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M18 6L6 18M6 6L18 18"
                                        stroke="#333"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>

                            </div>



                            <h3>Apply For This Job</h3>


                            <form>

                                <input
                                    type="text"
                                    placeholder="Full Name"
                                    required
                                />

                                <input
                                    type="email"
                                    placeholder="Email"
                                    required
                                />

                                <input
                                    type="tel"
                                    placeholder="Phone"
                                    required
                                />


                                <div className="file-upload">

                                    <FaFileUpload />

                                    <input
                                        type="file"
                                        required
                                    />

                                </div>



                                <button
                                    type="submit"
                                    className="submit-btn full-btn"
                                >

                                    Submit

                                </button>


                            </form>

                        </motion.div>

                    </motion.div>

                )}

            </AnimatePresence>

            {/* ===== CTA SECTION ===== */}
            <section className="about-cta-section">
                <motion.div
                    className="container"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-80px" }}
                >
                    <h2 className="text-uppercase">Let Us Help Your Business Move Forward</h2>
                    <p>
                        Fortune Cloud Solutions provides tailored IT staffing, industry-relevant training,
                        and career development services, empowering businesses and professionals to thrive
                        in the ever-evolving IT landscape.
                    </p>
                    <Link to="/contact">
                        <button className="about-cta-btn text-uppercase">
                            Get In Touch <FaArrowRight className="ms-2" />
                        </button>
                    </Link>
                </motion.div>
            </section>

        </motion.div>

    );

};

export default Jobs;